import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/palette";
import { UserSubRole } from "../../enums/entity.enum";
import { useTranslation } from "react-i18next";

type Props = {
  compareUsersList: { items: any[] };
  label: string;
  dataKey: string;
  isLastRow: boolean;
  isTranslated?: boolean;
};

const CompareRowText = ({ compareUsersList, label, dataKey, isLastRow, isTranslated }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        padding: "17px 27px",
        borderBottom: `${!isLastRow && "1px solid #EAECF0"}`,
        gap: "66px",
        "&:last-child": {
          borderBottom: "none",
        },
      }}
    >
      <Box sx={{ width: "237px" }}>
        <Typography
          variant="body14Bold"
          sx={{
            fontWeight: 700,
            color: colors.Dark1000,
          }}
        >
          {label}
        </Typography>
      </Box>
      {compareUsersList?.items?.map((user: any, index: number) => {
        const value = user[dataKey];

        const displayValue =
          Array.isArray(value) && value.length > 0
            ? value.map((skill: any) => skill.title).join(", ")
            : (typeof value === "number" && !isNaN(value)) || isTranslated
            ? value
            : value
            ? t(`components.compare.${value}`)
            : "N/A";

        return (
          <Box sx={{ width: "148px", textAlign: "center" }} key={index}>
            <Typography
              variant="body14Regular"
              sx={{
                color: colors.Dark1000,
              }}
            >
              {displayValue}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default CompareRowText;
